import { DocWithItems } from "@/components/DocWithItems";
import { StatusBadge } from "@/components/StatusBadge";
import { tanggal } from "@/lib/format";

const commonHeader = [
  { name: "number", label: "Nomor", required: true },
  { name: "client_id", label: "Klien", type: "select", optionsRef: "clients", required: true },
  { name: "project_id", label: "Proyek", type: "select", optionsRef: "projects", required: true, filterBy: "client_id" },
  { name: "contract_id", label: "Kontrak", type: "select", optionsRef: "contracts", filterBy: "project_id" },
  { name: "date", label: "Tanggal", type: "date", required: true },
];

export function PurchaseOrdersPage() {
  return (
    <DocWithItems title="Purchase Order" subtitle="PO klien beserta item material" endpoint="/purchase-orders" testId="po"
      listColumns={[
        { key: "number", label: "No. PO" },
        { key: "date", label: "Tanggal", render: (r) => tanggal(r.date) },
        { key: "items", label: "Item", render: (r) => `${(r.items || []).length} material` },
        { key: "invoice_rule", label: "Aturan Invoice", render: (r) => <span className="text-xs">{r.invoice_rule}</span> },
        { key: "status", label: "Status", render: (r) => <StatusBadge status={r.status} /> },
      ]}
      headerFields={[...commonHeader,
        { name: "valid_until", label: "Masa Berlaku", type: "date" },
        { name: "invoice_rule", label: "Aturan Invoice", type: "select", options: [
          { value: "one_per_dn", label: "Satu invoice per surat jalan" },
          { value: "combine_all", label: "Gabungkan seluruh SJ dalam PO" },
          { value: "combine_project_period", label: "Gabungkan per proyek & periode" },
          { value: "manual", label: "Pilih manual" }] },
        { name: "status", label: "Status", type: "select", options: [
          { value: "Aktif", label: "Aktif" }, { value: "Draft", label: "Draft" }, { value: "Dibatalkan", label: "Dibatalkan" }] },
      ]}
      itemFields={[{ name: "qty", label: "Qty Dipesan", type: "number" }]}
      defaultValues={{ status: "Aktif", invoice_rule: "combine_project_period", currency: "IDR" }} />
  );
}

export function DeliveryNotesPage() {
  return (
    <DocWithItems title="Surat Jalan" subtitle="Data surat jalan (sumber material). Koreksi dilakukan di aplikasi material." endpoint="/delivery-notes" testId="dn"
      readOnlyNote="Data ini berasal dari aplikasi kontrol material. Finance tidak boleh mengubah surat jalan secara langsung."
      listColumns={[
        { key: "number", label: "No. SJ" },
        { key: "date", label: "Tanggal Kirim", render: (r) => tanggal(r.date) },
        { key: "purchase_order_id", label: "PO", render: (r) => r.purchase_order_id || "-" },
        { key: "items", label: "Item", render: (r) => `${(r.items || []).length} material` },
        { key: "status", label: "Status", render: (r) => <StatusBadge status={r.status} /> },
      ]}
      headerFields={[...commonHeader,
        { name: "purchase_order_id", label: "Purchase Order", type: "select", optionsRef: "purchase_orders", filterBy: "project_id" },
        { name: "status", label: "Status Verifikasi", type: "select", options: [
          { value: "Terverifikasi", label: "Terverifikasi" }, { value: "Draft", label: "Draft" }] },
      ]}
      itemFields={[{ name: "qty", label: "Qty Aktual", type: "number" }]}
      defaultValues={{ status: "Terverifikasi" }} />
  );
}

export function ReturnNotesPage() {
  return (
    <DocWithItems title="Surat Pengembalian" subtitle="Data surat pengembalian (sumber material)." endpoint="/return-notes" testId="rn"
      readOnlyNote="Hanya pengembalian Terverifikasi/Disetujui yang memengaruhi saldo & tagihan. Koreksi dilakukan di aplikasi material."
      listColumns={[
        { key: "number", label: "No. SP" },
        { key: "date", label: "Tanggal Kembali", render: (r) => tanggal(r.date) },
        { key: "items", label: "Item", render: (r) => `${(r.items || []).length} material` },
        { key: "status", label: "Status", render: (r) => <StatusBadge status={r.status} /> },
      ]}
      headerFields={[...commonHeader,
        { name: "ref_dn", label: "Ref. Surat Jalan" },
        { name: "status", label: "Status", type: "select", options: [
          { value: "Terverifikasi", label: "Terverifikasi" }, { value: "Disetujui", label: "Disetujui" },
          { value: "Menunggu Sortir", label: "Menunggu Sortir" }, { value: "Draft", label: "Draft" }] },
      ]}
      itemFields={[
        { name: "good_qty", label: "Diterima Baik", type: "number" },
        { name: "rejected_qty", label: "Reject", type: "number" },
        { name: "lost_qty", label: "Hilang", type: "number" },
      ]}
      defaultValues={{ status: "Terverifikasi" }} />
  );
}
